'use client';

import { useAppDispatch, useAppSelector } from '@/store/hook';
import { closeModal } from '@/features/ui/uiModalSlice';
import IconModal from '@/components/ui/modal/IconModal';

export default function GlobalModalHost() {
  const dispatch = useAppDispatch();
  const { show, variant, title, message } = useAppSelector((s) => s.uiModal);

  return (
    <IconModal
      show={show}
      variant={variant}
      size="md"
      title={title}
      onClose={() => dispatch(closeModal())}
    >
      {message}
    </IconModal>
  );
}
